<ion-app>
  @if (!isIframe) {
    <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
